export const ORDERED_ROLES = {
  user: 0,
  admin: 1,
  super_admin: 2,
  basic_support_admin: 3,
  advanced_support_admin: 4,
  admin_support_manager: 5,
  developer_support: 6,
  customer_success_manager: 7,
  data_ops: 8,
};
